import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Typography, Paper, Grid, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import CoManagerDocumentsTable from './comanager-document-table';
import ViewWrapper from 'views/ViewWrapper';

const styles = theme => ({
  paper: {
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  actionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
  },
  actionButton: {
    marginRight: theme.spacing(1),
  },
  rightActionContianer: {
    textAlign: 'right',
  },
  toggleLabel: {
    marginRight: 0,
  },
  startLabel: {
    marginRight: theme.spacing(1),
  },
});

const ServiceDeal = ({ ...props }) => {
  const { classes } = props;
  const [search, setSearch] = useState('');

  const handleSearchUpdate = e => {
    setSearch(e.target.value);
  };

  return (
    <ViewWrapper>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <Typography className={classes.title} variant="h5">
                Co-Manager Training
              </Typography>
            </Grid>
            <Grid item xs={3} textAlign="right" className={classes.rightActionContianer}>
              <Link className={classes.actionButton} to={'/comanager-documents/create'}>
                <Button variant="contained">New Entry</Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <TextField label="Search" onBlur={handleSearchUpdate} />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <CoManagerDocumentsTable search={search} />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(ServiceDeal);
